module.exports = __webpack_public_path__ + "img/tempo.e00e8f2e.svg";